<template>
  <div class="device_control_page_wraper">
    <div class="close_img_top public_z_index6">
      <img
        src="~assets/img/controlpublic/control-guanbi-chahao.png"
        @click="$closeControlToast"
        alt
      />
    </div>
    <div class="devce_name public_z_index6 z_ellipsis1">
      {{ objData.remark }}
    </div>

    <!-- 开关按钮部分 -->
    <div class="device_023_top_btn_wraper">
      <div
        class="device_023_left_btn_wraper device023_top_public_btn"
        @click="device023BtnHandle(1)"
      >
        <img src="~assets/img/musicControl/music_kaiji.png" alt />
        <span>开机</span>
      </div>
      <div
        class="device_023_right_btn_wraper device023_top_public_btn"
        @click="device023BtnHandle(2)"
      >
        <img src="~assets/img/musicControl/music_guanji_1.png" alt />
        <span>关机</span>
      </div>
    </div>
    <!-- 音量样式部分 -->
    <div class="device_023_volume_wraper">
      <div
        class="device_023_mute_btn device_023_public_btn"
        @click="device023BtnHandle(3)"
      >
        <img src="~assets/img/musicControl/music_jingyin.png" alt />
      </div>
      <div
        class="device_023_decrease_volume_btn device_023_public_btn"
        @click="device023BtnHandle(5)"
      >
        <img src="~assets/img/musicControl/music_jianshao.png" alt />
      </div>
      <progress-bar
        class="progress_bar_023"
        @valueChange="valueChange"
        :width="150"
        :maxValue="100"
        :setValue="userControlData.openStateValue"
      ></progress-bar>
      <div
        class="device_023_increase_volume_btn device_023_public_btn"
        @click="device023BtnHandle(4)"
      >
        <img src="~assets/img/musicControl/music_zengjia.png" alt />
      </div>
    </div>
    <!-- 电视控制的中间样式部分 -->
    <div class="device_023_middle_wraper">
      <div class="device_023_middle_left_wraper">
        <div class="one_023_event_wraper">
          <div class="one_023_event_img" @click="device023BtnHandle(12)">
            <img src="~assets/img/movies/movies_zhuye.png" alt />
          </div>
          <span>主页</span>
        </div>
        <div class="one_023_event_wraper">
          <div class="one_023_event_img" @click="device023BtnHandle(13)">
            <img src="~assets/img/movies/movies_caidan.png" alt />
          </div>
          <span>菜单</span>
        </div>
        <div class="one_023_event_wraper">
          <div class="one_023_event_img" @click="device023BtnHandle(14)">
            <img src="~assets/img/movies/movies_fanhui.png" alt />
          </div>
          <span>返回</span>
        </div>
      </div>
      <div class="device_023_middle_right_wraper">
        <div
          class="device_023_queding press_down_active"
          @click="device023BtnHandle(11)"
        >
          确定
        </div>
        <div class="device_023_shang" @click="device023BtnHandle(7)"></div>
        <div class="device_023_xia" @click="device023BtnHandle(8)"></div>
        <div class="device_023_zuo" @click="device023BtnHandle(9)"></div>
        <div class="device_023_you" @click="device023BtnHandle(10)"></div>
      </div>
    </div>

    <!-- 自定义按钮样式部分--笨方法 -->
    <!-- <div class="movies_jiemuyuan_wraper">
      <div
        class="movies_one_zidingyi_wraper z_ellipsis1"
        @click="device023BtnHandle(21)"
      >
        {{ serve023ShowData[0].moviesName }}
      </div>
      <div
        class="movies_one_zidingyi_wraper z_ellipsis1"
        @click="device023BtnHandle(22)"
      >
        {{ serve023ShowData[1].moviesName }}
      </div>
      <div
        class="movies_one_zidingyi_wraper z_ellipsis1"
        @click="device023BtnHandle(23)"
      >
        {{ serve023ShowData[2].moviesName }}
      </div>
      <div
        class="movies_one_zidingyi_wraper z_ellipsis1"
        @click="device023BtnHandle(24)"
      >
        {{ serve023ShowData[3].moviesName }}
      </div>
      <div
        class="movies_one_zidingyi_wraper z_ellipsis1"
        @click="device023BtnHandle(25)"
      >
        {{ serve023ShowData[4].moviesName }}
      </div>
      <div
        class="movies_one_zidingyi_wraper z_ellipsis1"
        @click="device023BtnHandle(26)"
      >
        {{ serve023ShowData[5].moviesName }}
      </div>
      <div
        class="movies_one_zidingyi_wraper z_ellipsis1"
        @click="device023BtnHandle(27)"
      >
        {{ serve023ShowData[6].moviesName }}
      </div>
      <div
        class="movies_one_zidingyi_wraper z_ellipsis1"
        @click="device023BtnHandle(28)"
      >
        {{ serve023ShowData[7].moviesName }}
      </div>
      <div
        class="movies_one_zidingyi_wraper z_ellipsis1"
        @click="device023BtnHandle(29)"
      >
        {{ serve023ShowData[8].moviesName }}
      </div>
    </div> -->
    <!-- 自定义按钮样式部分--新方法 -->
    <div class="movies_jiemuyuan_wraper">
      <div
        v-for="(value, index) in serve023ShowData"
        :key="index"
        class="movies_one_zidingyi_wraper z_ellipsis1"
        @click="device023BtnHandle(value.moviesKey, value.moviesName)"
      >
        {{ value.moviesName }}
      </div>
    </div>
  </div>
</template>

<script>
// 红外控制的设备暂时不支持绝对音量的控制
/*1：电源开 2：电源关 3：静音 4，音量加 5：音量减 6:绝对音量 7：上 8：下 9：左 10：右
11：确定 12：主页 13：菜单 14：返回  21：自定义1  22：自2  23:自3  24：自4  25：自5  26：自6  27：自7  28：自8 29:自9*/
// import { controlBtnRequestHandle } from "components/content/control-toast/control-toast-classify/device-public-js";
import ProgressBar from 'components/common/progressbar/progress-bar'
import store from 'store/index' ///导入公共仓库

export default {
  data() {
    return {
      userControlData: this.objData
      // {
      //   openState: this.objData.openState, //*1：开机 2：关机 3：静音4 ....见上面详细说明
      //   openStateValue: this.objData.openStateValue, //绝对音量值 0-100  // 红外控制的设备暂时不支持绝对音量的控制
      //   openStateValue1: this.objData.openStateValue1, ///无用
      //   openStateValue2: this.objData.openStateValue2 ///无用
      // }
    }
  },
  components: {
    ProgressBar
  },
  props: {
    objData: Object, ///要控制设备的数据
    serve023ShowData: Array ////自定义按钮显示的数据
  },
  watch: {
    // "objData.openState": {
    //   // deep:true,
    //   handler: function(val) {
    //     ///保证服务器数据和用户设置的数据同步
    //     console.log(val);
    //     this.userControlData.openState = val;
    //   }
    // },
    // "objData.openStateValue": {
    //   // deep:true,
    //   handler: function(val) {
    //     ///保证服务器数据和用户设置的数据同步
    //     console.log(val);
    //     this.userControlData.openStateValue = val;
    //   }
    // },
    // "objData.openStateValue1": {
    //   // deep:true,
    //   handler: function(val) {
    //     ///保证服务器数据和用户设置的数据同步
    //     console.log(val);
    //     this.userControlData.openStateValue1 = val;
    //   }
    // },
    // "objData.openStateValue2": {
    //   // deep:true,
    //   handler: function(val) {
    //     ///保证服务器数据和用户设置的数据同步
    //     console.log(val);
    //     this.userControlData.openStateValue2 = val;
    //   }
    // }
  },

  methods: {
    valueChange(data) {
      // 红外控制的设备暂时不支持绝对音量的控制
      console.log('子组件传回的值' + data)
      if (this.userControlData.openStateValue === data) return
      this.userControlData.openState = 6 ///绝对音量命令
      this.userControlData.openStateValue = data

      // controlBtnRequestHandle(this.userControlData, this.objData); ///控制请求服务端的公共方法
    },
    device023BtnHandle(value, value2) {
      ////z这里为了场景配置  自定义文字的回显，与控制端代码略微不同
      console.log(this.userControlData)
      this.userControlData.openState = value

      // 要显示的自定义文字提交到仓库  //代号20211025-1  这里的value2 传过来并没有用需要服务端处理  // 暂时不回显实际的自定义文字内容 因为有BUG  需要服务端处理
      // if (value2 != undefined) {
      //   console.log(value2)
      //   store.dispatch('asyUpdataconfig023ShowDataText', value2) ///异步提交用户的账号信息到仓库
      // }
      console.log(value)

      // controlBtnRequestHandle(this.userControlData, this.objData); ///控制请求服务端的公共方法
    }
  },
  computed: {}
}
</script>

<style>
/* <!-- 电视控制的中间样式部分 --> */
.device_023_middle_wraper {
  width: 100%;
  height: 180px;

  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;

  margin-bottom: 10px;
}
.device_023_middle_left_wraper {
  height: 180px;
  width: 120px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
}
.one_023_event_img {
  height: 35px;
  width: 35px;
  background-color: #f5f5f5;
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;
}
.one_023_event_img:active {
  background: #a0a3a5;
}
.one_023_event_wraper {
  display: flex;

  justify-content: center;
  align-items: center;
}
.one_023_event_img {
  margin-right: 10px;
}
.one_023_event_img img {
  width: 21px;
  height: 21px;
}
.one_023_event_wraper span {
  font-size: 14px;
  color: #f5f5f5;
}
.device_023_middle_right_wraper {
  height: 180px;
  width: 180px;
  position: relative;
}
.device_023_queding {
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-color: #f5f5f5;
  border-radius: 50%;

  color: #282828;
  font-size: 14px;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.device_023_shang {
  width: 0px;
  height: 0px;
  border: 20px solid;
  border-color: transparent transparent #f5f5f5 transparent;

  position: absolute;
  top: 0px;
  left: 70px;
}

.device_023_xia {
  width: 0px;
  height: 0px;
  border: 20px solid;
  border-color: #f5f5f5 transparent transparent transparent;

  position: absolute;
  bottom: 0px;
  left: 70px;
}
.device_023_zuo {
  width: 0px;
  height: 0px;
  border: 20px solid;
  border-color: transparent #f5f5f5 transparent transparent;
  position: absolute;
  top: 70px;
  left: 0px;
}
.device_023_you {
  width: 0px;
  height: 0px;
  border: 20px solid;
  border-color: transparent transparent transparent #f5f5f5;

  position: absolute;
  top: 70px;
  right: 0px;
}
.device_023_shang:active {
  border-color: transparent transparent #a0a3a5 transparent;
}
.device_023_xia:active {
  border-color: #a0a3a5 transparent transparent transparent;
}
.device_023_zuo:active {
  border-color: transparent #a0a3a5 transparent transparent;
}
.device_023_you:active {
  border-color: transparent transparent transparent #a0a3a5;
}
.press_down_active:active {
  background: #a0a3a5;
}
/* 自定义按钮样式部分 */
.movies_jiemuyuan_wraper {
  width: 100%;
  height: 120px;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  color: #f5f5f5;
  font-size: 14px;
}
.movies_one_zidingyi_wraper {
  width: 75px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border: 1px solid var(--control-outline-color);
  border-radius: 4px;
}
.movies_one_zidingyi_wraper:active {
  background: #a0a3a5;
}

/* 开关按钮样式部分 */
.device_023_top_btn_wraper {
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.device023_top_public_btn {
  display: flex;
  justify-content: center;
  align-items: center;

  /* background-color: #f5f5f5; */
  width: 70px;
  height: 35px;
  border: 1px solid var(--control-outline-color);
  border-radius: 4px;

  color: #f5f5f5;
  font-size: 14px;
}
.device023_top_public_btn:active {
  background: #a0a3a5;
}
.device023_top_public_btn img {
  width: 21px;
  height: 21px;

  margin-right: 5px;
}
.device_023_left_btn_wraper {
  margin-right: 160px;
  background-color: #f5f5f5;
  color: #282828;
}
/* 音量按钮部分 */
.device_023_volume_wraper {
  width: 100%;
  height: 80px;
  /* line-height: 80px; */
  text-align: center;
  position: relative;
  margin-bottom: 10px;
}
/* .device_023_volume_wraper::after{
  content: "";
  display: inline-block;
  height: 1px;
  width: 300px;
  background-color:#999999;

  position: relative;
  top: 75px;
} */
.device_023_public_btn {
  display: inline-block;
  background-color: #f5f5f5;
  width: 40px;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  text-align: center;
}

.device_023_public_btn img {
  width: 21px;
  height: 21px;
  margin-top: 4px;
}

.device_023_mute_btn {
  position: absolute;
  top: 42px;
  left: 0px;

  border-radius: 12px;
}
.device_023_increase_volume_btn {
  position: absolute;
  top: 42px;
  right: 0px;
}
.device_023_decrease_volume_btn {
  position: absolute;
  top: 42px;
  left: 53px;
}
.progress_bar_023 {
  display: inline-block;
  position: absolute;
  left: 80px;
}
.device_023_public_btn:active {
  background: #a0a3a5;
}
/* 其他 */
</style>
